import React, { FC } from 'react';
import { MarginalItemProps } from './PageWrapper';
import styled from 'styled-components';
import { SiteNavigationItem } from './SiteNavigationItem';
import { SiteNavigationBox } from './SiteNavigationBox';


export interface SiteNavigationProps {
  items: MarginalItemProps[];
}

const SideNavigationContent = styled.ul`
  list-style: none;
`;
export const SiteNavigation: FC<SiteNavigationProps> = (props) => {
  const { items } = props;

  return (
    <SiteNavigationBox whiteBackground={true}>
      <SideNavigationContent>
        {
          items.map((item) => {
            return <SiteNavigationItem item={item} key={item.text}/>;
          })
        }
      </SideNavigationContent>
    </SiteNavigationBox>
  );
};
